import { IconButton, Menu, MenuItem, TableCell, TableRow } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import React from 'react';

const UserTableRow = ({
  user, 
  renderStates, 
  openMenu, 
  menuAnchorEl, 
  closeMenu, 
  openEdit, 
  handleDeleteUser, 
  menuUserId 
}: {
    user: {
      user_id: string;
      full_name: string;
      email: string;
      is_admin: boolean;
      last_login: string;
      states: string[];
    };
    renderStates: (stateCodes: string[]) => string;
    openMenu: (event: React.MouseEvent<HTMLElement>, userId: string) => void;
    menuAnchorEl: HTMLElement | null;
    closeMenu: () => void;
    openEdit: (user: {
      user_id: string;
      full_name: string;
      email: string;
      is_admin: boolean;
      last_login: string;
      states: string[];
    }) => void;
    handleDeleteUser: (userId: string) => void;
    menuUserId: string | null;
  }) => {
  return (
    <TableRow key={user.user_id} hover>
      <TableCell>{user.full_name}</TableCell>
      <TableCell>{user.email}</TableCell>
      <TableCell>••••••••</TableCell>
      <TableCell>{user.is_admin ? 'Admin' : 'User'}</TableCell>
      <TableCell>{renderStates(user.states)}</TableCell>
      <TableCell>{new Date(user.last_login).toLocaleString()}</TableCell>
      <TableCell align="right">
        <IconButton onClick={(e) => openMenu(e, user.user_id)} size="small">
          <MoreVertIcon />
        </IconButton>
        <Menu
          anchorEl={menuAnchorEl}
          open={Boolean(menuAnchorEl) && menuUserId === user.user_id}
          onClose={closeMenu}
        >
          <MenuItem
            onClick={() => {
              closeMenu();
              openEdit(user);
            }}
          >
            Update
          </MenuItem>
          <MenuItem
            onClick={() => {
              closeMenu();
              const yes = window.confirm('Delete this user?');
              if (yes) handleDeleteUser(user.user_id);
            }}
          >
            Delete
          </MenuItem>
        </Menu>
      </TableCell>
    </TableRow>
  );
}

export default UserTableRow;